import React from 'react';

const ErrorPages = ({ type = '404', onHomeClick }) => {
  const handleHomeClick = () => {
    if (onHomeClick) {
      onHomeClick();
    } else {
      window.location.href = '/';
    }
  };

  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');

    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    body {
      font-family: 'Poppins', sans-serif;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .error-page {
      min-height: 100vh;
      background: #000000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      font-family: 'Poppins', sans-serif;
    }

    .error-container {
      text-align: center;
      animation: fadeIn 0.6s ease-out;
      max-width: 700px;
      width: 100%;
      padding: 1rem;
    }

    .error-code {
      font-size: clamp(4rem, 15vw, 12rem);
      font-weight: 700;
      color: #ffffff;
      line-height: 1;
      margin-bottom: 1rem;
      letter-spacing: -0.02em;
    }

    .error-title {
      font-size: clamp(0.75rem, 2vw, 0.95rem);
      font-weight: 100;
      color: #cccccc;
      text-transform: uppercase;
      letter-spacing: clamp(0.08em, 1vw, 0.15em);
      margin-bottom: 2rem;
      opacity: 0.8;
      padding: 0 1rem;
    }

    .error-actions {
      display: flex;
      gap: 1rem;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: 2rem;
      padding: 0 1rem;
    }

    .btn {
      padding: 0.875rem 2rem;
      font-size: clamp(0.8rem, 2vw, 0.95rem);
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      border: none;
      border-radius: 50px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-family: 'Poppins', sans-serif;
      min-width: 140px;
      white-space: nowrap;
    }

    .btn-primary {
      background: #ffffff;
      color: #000000;
    }

    .btn-primary:hover {
      background: #e0e0e0;
      transform: translateY(-2px);
    }

    .btn-primary:active {
      transform: translateY(0);
    }

    .btn-secondary {
      background: transparent;
      color: #ffffff;
      border: 2px solid #ffffff;
    }

    .btn-secondary:hover {
      background: #ffffff;
      color: #000000;
      transform: translateY(-2px);
    }

    .btn-secondary:active {
      transform: translateY(0);
    }

    .error-footer {
      margin-top: 3rem;
      padding-top: 2rem;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .footer-text {
      color: rgba(255, 255, 255, 0.6);
      font-size: clamp(0.8rem, 2vw, 0.9rem);
      font-weight: 400;
      padding: 0 1rem;
      line-height: 1.6;
    }

    .footer-link {
      color: #ffffff;
      text-decoration: none;
      font-weight: 600;
      transition: all 0.3s ease;
      word-break: break-word;
    }

    .footer-link:hover {
      color: #cccccc;
    }



    @media (max-width: 768px) {
      .error-page {
        padding: 1.5rem 1rem;
      }

      .error-container {
        padding: 0.5rem;
      }

      .error-code {
        margin-bottom: 0.75rem;
      }
      
      .error-title {
        margin-bottom: 1.5rem;
      }
      
      .error-actions {
        flex-direction: column;
        align-items: center;
        gap: 0.875rem;
        margin-bottom: 1.5rem;
      }
      
      .btn {
        width: 100%;
        max-width: 280px;
        padding: 1rem 1.5rem;
      }

      .error-footer {
        margin-top: 2rem;
        padding-top: 1.5rem;
      }


    }

    @media (max-width: 480px) {
      .error-page {
        padding: 1rem 0.5rem;
      }

      .error-title {
        padding: 0 0.5rem;
      }

      .error-actions {
        padding: 0 0.5rem;
      }
      
      .btn {
        max-width: 100%;
        font-size: 0.85rem;
        padding: 0.875rem 1.25rem;
      }

      .footer-text {
        padding: 0 0.5rem;
        font-size: 0.8rem;
      }


    }

    @media (max-width: 360px) {
      .error-code {
        font-size: 3.5rem;
      }

      .btn {
        font-size: 0.8rem;
        letter-spacing: 0.08em;
      }
    }
  `;

  // 404 Page
  if (type === '404') {
    return (
      <>
        <style>{styles}</style>
        <div className="error-page">
          <div className="error-container">
            <h1 className="error-code">404</h1>
            <h2 className="error-title">We are sorry, but the page you requested was not found</h2>
            
            <div className="error-actions">
              <button onClick={handleHomeClick} className="btn btn-primary">
                GO HOME
              </button>
              <button onClick={() => window.location.href = 'mailto:dontcrytech@gmail.com'} className="btn btn-secondary">
                CONTACT US
              </button>
            </div>

            <div className="error-footer">
              <p className="footer-text">
                Need help? Contact us at <a href="mailto:dontcrytech@gmail.com" className="footer-link">dontcrytech@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }

  // 500 Server Error
  if (type === '500' || type === 'server') {
    return (
      <>
        <style>{styles}</style>
        <div className="error-page">
          <div className="error-container">
            <h1 className="error-code">500</h1>
            <h2 className="error-title">Internal server error - Please try again later</h2>
            
            <div className="error-actions">
              <button onClick={() => window.location.reload()} className="btn btn-primary">
                REFRESH PAGE
              </button>
              <button onClick={handleHomeClick} className="btn btn-secondary">
                GO HOME
              </button>
            </div>

            <div className="error-footer">
              <p className="footer-text">
                If the problem persists, contact <a href="mailto:dontcrytech@gmail.com" className="footer-link">dontcrytech@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }

  // 403 Forbidden
  if (type === '403') {
    return (
      <>
        <style>{styles}</style>
        <div className="error-page">
          <div className="error-container">
            <h1 className="error-code">403</h1>
            <h2 className="error-title">Access forbidden - You don't have permission to access this page</h2>
            
            <div className="error-actions">
              <button onClick={handleHomeClick} className="btn btn-primary">
                GO HOME
              </button>
              <button onClick={() => window.location.href = 'mailto:dontcrytech@gmail.com'} className="btn btn-secondary">
                CONTACT US
              </button>
            </div>

            <div className="error-footer">
              <p className="footer-text">
                Need help? Contact us at <a href="mailto:dontcrytech@gmail.com" className="footer-link">dontcrytech@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }

  // Default 404
  return (
    <>
      <style>{styles}</style>
      <div className="error-page">
        <div className="error-container">
          <h1 className="error-code">404</h1>
          <h2 className="error-title">We are sorry, but the page you requested was not found</h2>
          <div className="error-actions">
            <button onClick={handleHomeClick} className="btn btn-primary">
              GO HOME
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorPages;